<template>
  <div class="navigation">
    <div class="PC">
      <div class="top-border"></div>
      <nav id="navigation-container">
        <div class="navigation-catalog">
          <router-link to="/" class="router-link-style-home">
            <img class="navigation-home" style="background-color: #ffffff;" src="../../assets/images/pc/home.png"/>
          </router-link>
          <router-link :to="{name: 'column_list', params: {id:'003',title:['晚装']}}" class="router-link-style">晚装</router-link>
          <router-link :to="{name: 'column_list', params: {id:'007',title:['时尚']}}" class="router-link-style">时尚</router-link>
          <router-link :to="{name: 'column_list', params: {id:'008',title:['舒逸']}}" class="router-link-style">舒逸</router-link>
          <div class="left-border"></div>
          <!--<router-link :to="{name: 'column_list', params: {id:'004',title:['包包']}}" class="router-link-style">包包</router-link>-->
          <router-link :to="{name: 'column_list', params: {id:'009',title:['运动']}}" class="router-link-style">运动</router-link>
          <!--<div class="left-border"></div>-->
          <!--<router-link :to="{name: 'column_list', params: {id:'006',title:['最新推荐']}}" class="router-link-style">最新推荐</router-link>-->
          <!--<router-link :to="{name: 'column_list', params: {id:'007',title:['经典单品']}}" class="router-link-style">经典单品</router-link>-->
          <router-link :to="{name: 'column_list', params: {id:'010',title:['经典']}}" class="router-link-style">经典</router-link>
        </div>
        <div class="navigation-other">
          <router-link to="/ts/world" class="router-link-style">蹀愫世界</router-link>
          <router-link to="/TS/video" class="router-link-style">蹀愫视界</router-link>
        </div>
      </nav>
    </div>
    <div class="mobile">
      <nav class="nav">
        <div class="nav-main" :class="isExpandNav?'navMainShow':'navMainHide'">
          <router-link to="/" class="router-link-style">
            <div class="navigation-home" @click="expandNav(!isExpandNav)">
              <div>
                <img src="../../assets/images/mobile/home.png" alt="">
              </div>
              <div>
                <span class="navigation-text">主页</span>
              </div>
            </div>
          </router-link>
        </div>
        <div class="nav-brief">
          <div class="nav-sign">
            <div class="expand-button" @click="expandNav(!isExpandNav)">
              <img src="../../assets/images/mobile/navDetail.png" alt="">
            </div>
            <div class="TS-logo">
              <img src="../../assets/images/mobile/logo.png" alt="">
            </div>
          </div>
          <div class="nav-orther">
            <div><router-link to="/ts/world">蹀愫世界</router-link></div>
            <div class="line"></div>
            <div><router-link to="/TS/video">蹀愫视界</router-link></div>

          </div>
        </div>
      </nav>
      <div class="nav-slide-down" :style="{height:slideHeight+'px'}"
           :class="isExpandNav?'navslideDownShow':'navslideDownHide'">
        <!--<div class="">-->
          <router-link :to="{name: 'column_list', params: {id:'002'}}" class="router-link-style">
            <div class="item-black border-1px nav-slide-down-item" @click="expandNav(!isExpandNav)">
              <div>时尚</div>
              <div class="icon-right"><img src="../../assets/images/mobile/whiteArrow.png" alt=""></div>
            </div>
          </router-link>
          <router-link :to="{name: 'column_list', params: {id:'003'}}" class="router-link-style">
            <div class="item-black border-1px nav-slide-down-item" @click="expandNav(!isExpandNav)">
              <div>晚装</div>
              <div class="icon-right"><img src="../../assets/images/mobile/whiteArrow.png" alt=""></div>
            </div>
          </router-link>
          <router-link :to="{name: 'column_list', params: {id:'001'}}" class="router-link-style">
            <div class="item-black border-1px nav-slide-down-item" @click="expandNav(!isExpandNav)">
              <div>运动</div>
              <div class="icon-right"><img src="../../assets/images/mobile/whiteArrow.png" alt=""></div>
            </div>
          </router-link>

          <router-link :to="{name: 'column_list', params: {id:'004'}}" class="router-link-style">
            <div class="item-white border-1px nav-slide-down-item" @click="expandNav(!isExpandNav)">
              <div>包包</div>
              <div class="icon-right"><img src="../../assets/images/mobile/grayArrow.png" alt=""></div>
            </div>
          </router-link>
          <router-link :to="{name: 'column_list', params: {id:'005'}}" class="router-link-style">
            <div class="item-white border-1px nav-slide-down-item" @click="expandNav(!isExpandNav)">
              <div>舒逸</div>
              <div class="icon-right"><img src="../../assets/images/mobile/grayArrow.png" alt=""></div>
            </div>
          </router-link>
          <router-link :to="{name: 'column_list', params: {id:'006'}}" class="router-link-style">
            <div class="item-white border-1px nav-slide-down-item" @click="expandNav(!isExpandNav)">
              <div>最新推荐</div>
              <div class="icon-right"><img src="../../assets/images/mobile/grayArrow.png" alt=""></div>
            </div>
          </router-link>
          <router-link :to="{name: 'column_list', params: {id:'007'}}" class="router-link-style">
            <div class="item-white border-1px nav-slide-down-item" @click="expandNav(!isExpandNav)">
              <div>经典单品</div>
              <div class="icon-right"><img src="../../assets/images/mobile/grayArrow.png" alt=""></div>
            </div>
          </router-link>
          <router-link to="/ts/world" class="router-link-style">
            <div class="item-white border-1px nav-slide-down-item" @click="expandNav(!isExpandNav)">
              <div>蹀愫世界</div>
              <div class="icon-right"><img src="../../assets/images/mobile/grayArrow.png" alt=""></div>
            </div>
          </router-link>
          <router-link to="/TS/video" class="router-link-style">
            <div class="item-white border-1px nav-slide-down-item" @click="expandNav(!isExpandNav)">
              <div>蹀愫视觉</div>
              <div class="icon-right"><img src="../../assets/images/mobile/grayArrow.png" alt=""></div>
            </div>
          </router-link>
        </div>
      <!--</div>-->
      <div class="background-max" :style="{display:isExpandNav?'block':'none',height:slideHeight+'px'}"
           @click="expandNav(!isExpandNav)"></div>
    </div>
  </div>

</template>

<script>
import {
  mapState,
  mapMutations
} from 'vuex'

export default {
  name: 'navigation',
  data: function () {
    return {}
  },
  methods: {
    ...mapMutations(['expandNav'])
  },
  computed: {
    ...mapState(['isExpandNav']),
    slideHeight: function () {
      if (typeof document !== 'undefined') {
        return document.documentElement.clientHeight
      }
    }
  }
}
</script>

<style lang="less" scoped>
  @import "navigation";
  @import "navigationMobile";
</style>



// WEBPACK FOOTER //
// src/layout/header/navigation.vue